import React, { FC } from 'react';
import { SkappaCompleteSelectProps } from './SkappaCompleteSelectProps';
import Select, { Option } from '@ingka/select';
const SkappaCompleteSelect: FC<SkappaCompleteSelectProps> = ({
  options,
  onChange,
  value,
  disabled,
  label,
  id,
  disabledOption,
}) => {
  return (
    <Select
      id={id || label.split(' ').join('-').toLowerCase()}
      label={label}
      onChange={(e) => onChange(e.target.value)}
      value={value}
      disabled={disabled}
    >
      {Object.keys(options).map((opt) => (
        <Option
          disabled={disabledOption === opt}
          key={`${opt}-${Math.random()}`}
          value={opt}
          name={options[opt]}
        />
      ))}
    </Select>
  );
};

export default SkappaCompleteSelect;
